var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7354 23.4899L46.5304 32.8949C44.6404 41.0174 40.9054 44.3024 33.8854 43.6274C32.7604 43.5374 31.5454 43.3349 30.2404 43.0199L26.4604 42.1199C17.0779 39.8924 14.1754 35.2574 16.3804 25.8524L18.5854 16.4249C19.0354 14.5124 19.5754 12.8474 20.2504 11.4749C22.8829 6.0299 27.3604 4.5674 34.8754 6.3449L38.6329 7.2224C48.0604 9.4274 50.9404 14.0849 48.7354 23.4899Z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8853 43.6276C32.4903 44.5726 30.7353 45.3601 28.5978 46.0576L25.0428 47.2276C16.1103 50.1076 11.4078 47.7001 8.50528 38.7676L5.62528 29.8801C2.74528 20.9476 5.13028 16.2226 14.0628 13.3426L17.6178 12.1726C18.5403 11.8801 19.4178 11.6326 20.2503 11.4751C19.5753 12.8476 19.0353 14.5126 18.5853 16.4251L16.3803 25.8526C14.1753 35.2576 17.0778 39.8926 26.4603 42.1201L30.2403 43.0201C31.5453 43.3351 32.7603 43.5376 33.8853 43.6276Z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4404 19.1924L39.3529 21.9599",
    stroke: "#00A6A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2354 27.8999L32.7604 29.5649",
    stroke: "#00A6A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote2);
export default __webpack_public_path__ + "static/media/note-2.0767b085ea8dc816fddf1413d464d3c4.svg";
export { ForwardRef as ReactComponent };